export default __webpack_public_path__ + "static/media/icon_asignada_fail.6898ee42.svg";